import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewCategoryComponent } from './new-category.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    NewCategoryComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    NewCategoryComponent
  ]
})
export class NewCategoryModule { }
